/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** Open external links in the header and footer in a new tab */
function handleExternalLinks() {
    var links = document.querySelectorAll(".Header__MainNav a,.SidebarMenu a,.Footer a,.CollectionList--teamOnix a");
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].relList.add('noreferrer', 'noopener');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    handleExternalLinks();
})



// This script to manage data flow from Paperform form submissions to GTM.
window.addEventListener("message", (event) => {
    if (typeof event.data != "string" ||
      !event.data.startsWith("paperform:")
    )
      return;
  
    try {
      decodedData = JSON.parse(event.data.substring(10));
    } catch (e) {
      return;
    }
  
    if (
      !decodedData.hasOwnProperty("action") ||
      decodedData.action != "submission"
    )
      return;
  
    window.dataLayer.push({
      event: "request_form_submitted",
      formLocation: window.location.pathname,
    });
  });

// Desktop Search Type-ahead
(function() {
  const searchInput = document.querySelector('.Search__Input--v2[name="q"]');
  const searchElement = document.getElementById('Search');
  const searchResultsElement = searchElement ? searchElement.querySelector('.Search__Results') : null;
  const searchInner = document.querySelector('.Search__Inner');
  const searchFormV1 = document.querySelector('.Search__Form--v1');
  const pageOverlay = document.querySelector('.PageOverlay');
  let lastInputValue = '';
  let debounceTimer = null;

  if (!searchInput || !searchElement || !searchResultsElement) return;

  function debounce(fn, delay) {
    return function() {
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        fn.apply(null, args);
      }, delay);
    };
  }

  function resetSearch() {
    searchResultsElement.innerHTML = '';
    searchResultsElement.setAttribute('aria-hidden', 'true');
    if (searchFormV1 && searchFormV1.style.visibility === 'hidden') {
      searchFormV1.style.visibility = 'visible';
    }
  }

  function closeSearch() {
    searchElement.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (pageOverlay) pageOverlay.classList.remove('is-visible');
    const headerSection = document.querySelector('#shopify-section-header');
    if (headerSection) headerSection.style.zIndex = '';
    resetSearch();
  }

  const onInput = debounce(function(e) {
    const value = e.target.value;
    lastInputValue = value;

    if (!value || value.trim() === '') {
      closeSearch();
      return;
    }

    const searchMode = (window.theme && window.theme.searchMode) ? window.theme.searchMode : 'product';
    const queries = [
      fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(value) + '*&type=product', {
        method: 'GET',
        credentials: 'same-origin'
      })
    ];

    if (searchMode !== 'product') {
      queries.push(
        fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(value) + '*&type=' + searchMode.replace('product,', ''), {
          method: 'GET',
          credentials: 'same-origin'
        })
      );
    }

    Promise.all(queries)
    .then(function(responses) {
      return Promise.all(responses.map(function(r) { return r.text(); }));
    })
    .then(function(contents) {
      if (lastInputValue !== value) return;

      if (window.innerWidth >= 1140) {
        if (searchInner) {
          searchInner.style.display = 'block';
          searchInner.style.visibility = 'visible';
        }
        if (searchFormV1) {
          searchFormV1.style.visibility = 'hidden';
        }
      }

      if (pageOverlay) pageOverlay.classList.add('is-visible');
      const headerSection = document.querySelector('#shopify-section-header');
      if (headerSection) headerSection.style.zIndex = 10;

      if (searchMode === 'product') {
        searchResultsElement.innerHTML = contents[0];
      } else {
        searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">' +
          '<div class="PageLayout__Section">' + contents[0] + '</div>' +
          '<div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div>' +
        '</div>';
      }

      searchElement.setAttribute('aria-hidden', 'false');
      searchResultsElement.setAttribute('aria-hidden', 'false');
    });
  }, 250);

  searchInput.addEventListener('input', onInput);

  if (pageOverlay) {
    pageOverlay.addEventListener('click', closeSearch);
  }

  document.body.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="close-search"]')) {
      closeSearch();
    }
  });
})();
